var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_FlowTemplatesMessage_list_dialog_editConfigTitle"
      ),
      dialog: _vm.show,
      width: "700",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_FlowTemplatesMessage_list_dialog_templateLabel",
                            items: _vm.FlowTemplates,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.Data.flow_template_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "flow_template_uuid", $$v)
                            },
                            expression: "Data.flow_template_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_FlowTemplatesMessage_list_dialog_sendtypeLabel",
                            items: _vm.messageTypeData,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "view_fields",
                            "item-value": "value_field",
                          },
                          model: {
                            value: _vm.Data.message_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "message_type_uuid", $$v)
                            },
                            expression: "Data.message_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_FlowTemplatesMessage_list_dialog_templateStatusLabel",
                            items: _vm.Operating,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.operating_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "operating_status", $$v)
                            },
                            expression: "Data.operating_status",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_FlowTemplatesMessage_list_dialog_sendObjectLabel",
                            items: _vm.sendObject,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.Data.send_object,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "send_object", $$v)
                            },
                            expression: "Data.send_object",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.toSave, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }